<template>
    <div
        :id="'vehicle-' + vehicle_item.id"
        class="vehicle-item-component pb-3"
        v-if="vehicle_item"
    >
        <div class="rounded shadow-sm mx-1">
            <div>
                <router-link :to="viewRoute">
                    <div class="position-relative w-100">
                        <img
                            :src="imageUrls.length ? imageUrls[0] : '/images/no-image.png'"
                            alt=""
                            class="vehicle-item-image"
                        >
                    </div>
                </router-link>
                <div class="details px-2 py-3">
                    <div>
                        <div class="d-flex justify-content-start align-items-center right-section mb-2">
                            <h6 class="card-title right-card-title font-16 my-0">
                                <span class="bold">{{ vehicle.price | currency }}</span><br>
                                <span class="km-text"/>
                            </h6>
                            <div>
                                <star-vehicle
                                    :vehicle="vehicle_item"
                                    @removedFromShortlist="($vehicle) => {$emit('removedFromShortlist', $vehicle )}"
                                />
                            </div>
                            <div>
                                <p>
                                    <span
                                        :title="getStatusTooltip(vehicle.status)"
                                        v-b-tooltip.hover
                                    >
                                        <i :class="[vehicleStatusClass]"
                                           class="mdi mdi-checkbox-blank-circle"/>
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div class="position-relative">
                            <h6 class="text-truncate w-100">
                                {{ getVehicleItemFormattedShortenedName(vehicle_item) }}
                            </h6>
                        </div>
                        <span class="d-block text-truncate w-100" style="color: #9ca3af;">
                            {{ truncate(getVehicleItemFormattedName(vehicle_item), 35, '...') }}
                        </span>
                        <div class="row mt-4">
                            <div class="col-6 col-sm-6 text-center">
                                <div class="icon-list-holder">
                                    <manual-icon />
                                </div>
                                <small class="text-nowrap">{{ getVehicleItemTransmissionType(vehicle_item) }}</small>
                            </div>
                            <div class="col-6 col-sm-6 text-center">
                                <div class="icon-list-holder">
                                    <diesel-icon />
                                </div>
                                <small class="text-nowrap">{{ getVehicleItemFuelType(vehicle_item) }}</small>
                            </div>
                            <div class="col-6 col-sm-6 text-center">
                                <div class="icon-list-holder">
                                    <kilometer-icon />
                                </div>
                                <small class="text-nowrap">{{ getVehicleKiloMeters(vehicle_item) }}</small>
                            </div>
                            <div class="col-6 col-sm-6 text-center">
                                <div class="icon-list-holder">
                                    <four-seats-icon />
                                </div>
                                <small class="text-nowrap">4 Seats</small>
                            </div>
                        </div>
                    </div>
                    <div v-if="isWholesale" style="margin-bottom: 5px;">
                        <span class="badge badge-secondary">Wholesale</span>
                    </div>
                    <div :class="{ 'mt-4' : !isWholesale }">
                        <button @click="editVehicle()"
                                class="btn btn-sm btn-secondary waves-effect waves-light mt-1"
                                type="button"
                                v-if="canEdit">
                            <i class="mdi mdi-pencil"/>
                            Edit
                        </button>
                        <button @click="viewVehicle"
                                class="btn btn-sm btn-secondary waves-effect waves-light mt-1"
                                type="button">
                            <i class="mdi mdi-details"/>
                            Details
                        </button>
                        <button @click="onHandleDeal()"
                                class="btn btn-sm btn-primary waves-effect waves-light mt-1"
                                type="button"
                                v-if="shouldShowDealButton()"
                                >
                            <i class="mdi mdi-handshake"/>
                            Deal
                        </button>
                        <button
                            @click="share()"
                            class="btn btn-sm btn-primary waves-effect waves-light mt-1"
                            type="button"
                        >
                            <i class="mdi mdi-send"/>
                            Send to
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <share-modal
            :vehicle="vehicle"
            @success="onSuccessShare"
            ref="shareModal"
        />
    </div>
</template>

<script>
import ImageSwiper from "@/components/custom/ImageSwiper";
import StarVehicle from "@/components/main/StarVehicle";
import ShareModal from "@/components/main/vehicle/ShareModal";
import DieselIcon from "@/components/main/icons/DieselIcon";
import FourSeatsIcon from "@/components/main/icons/FourSeatsIcon";
import KilometerIcon from "@/components/main/icons/KilometerIcon";
import ManualIcon from "@/components/main/icons/ManualIcon";

import Routes from "@/constants/routes";
import Roles from "@/constants/roles";
import VehicleStatus from "@/constants/vehicle-statuses";
import VehicleUtils from "@/utils/vehicle";
import vehicle_mixin from "@/mixins/vehicle";

export default {
    mixins: [vehicle_mixin],
    props: {
        vehicle: {
            type: Object,
            required: true
        }
    },
    components: {
        ImageSwiper,
        StarVehicle,
        ShareModal,
        DieselIcon,
        FourSeatsIcon,
        KilometerIcon,
        ManualIcon,
    },
        data() {
            return {
                Roles,
                Routes,
                VehicleStatus,
                vehicle_item: null,
                front_index: null,
            }
        },
        created() {
            this.vehicle_item = _.cloneDeep(this.vehicle);
            VehicleUtils.arrangeVehicleImages(this.vehicle_item.images);
        },
        computed: {
            canEdit() {
                return this.vehicle.company_id === this.$store.state.user.companies[0].id && this.hasRole([Roles.dealer_principle, Roles.sales_manager])
            },
            imageUrls() {
                if (!this.vehicle_item) {
                    return [];
                }
                return _.map(this.vehicle_item.images, image => image.url)
            },
            viewRoute() {
                return {
                    name: Routes.view_vehicle,
                    params: {
                        id: this.vehicle_item.id,
                    },
                    query: {
                        back: this.$route.fullPath
                    }
                }
            },
        },
        methods: {
            viewVehicle() {
                this.$router.push({
                    name: Routes.view_vehicle,
                    params: {
                        id: this.vehicle_item.id,
                    },
                    query: {
                        back: this.$route.fullPath
                    }
                })
            },
            onHandleDeal() {
                const currCompanyDeal = this.vehicle.deals.find(deal => deal.buyer?.companies[0].id === this.$store.state.user.companies[0].id);

                this.$router.push({
                    name: currCompanyDeal ? Routes.message : Routes.create_deal,
                    params: currCompanyDeal ? {
                        deal_id: currCompanyDeal.id,
                        customer_id: currCompanyDeal.seller_id,
                    } :  {
                        vehicle_id: this.vehicle_item.id
                    },
                    query: {
                        back: this.$route.fullPath
                    }
                });
            },
            editVehicle() {
                this.$router.push({
                    name: Routes.edit_vehicle,
                    params: {
                        id: this.vehicle_item.id
                    },
                    query: {
                        back: this.$route.fullPath
                    }
                });
            },
            share() {
                this.$refs.shareModal.show();
            },
            onSuccessShare(share) {
                this.$refs.shareModal.hide();
            },
            getVehicleItemFormattedName(vehicle) {
                return vehicle.formatted_name;
            },
            getVehicleItemFormattedShortenedName(vehicle) {
                return vehicle.formatted_shortened_name;
            },
            getVehicleItemTransmissionType(vehicle) {
                return vehicle.transmission?.name;
            },
            getVehicleItemFuelType(vehicle) {
                return vehicle.fuel_type?.name;
            },
            getVehicleKiloMeters(vehicle) {
                if (vehicle.mileage) {
                    return `${ Number(vehicle.mileage).toLocaleString() } km`
                }
                return '-'
            },
            truncate(text, length, suffix) {
                if (text.length > length) {
                    return text.substring(0, length) + suffix;
                } else {
                    return text;
                }
            },
            shouldShowDealButton() {
                if (this.hasRole([Roles.sales_person])) {
                    return false;
                }

                const isVehicleOwnedByCurrentCompany = this.vehicle.company_id !== this.$store.state.user.companies[0].id;

                if (isVehicleOwnedByCurrentCompany) {
                    if (!this.vehicle?.deals?.find(deal => deal.buyer?.companies[0].id === this.$store.state.user.companies[0].id) && isVehicleOwnedByCurrentCompany) {
                        return true;
                    }

                    return this.vehicle.deals.find(deal => deal.buyer?.companies[0].id === this.$store.state.user.companies[0].id);
                } else {
                    if (!this.vehicle?.deals?.find(deal => deal.buyer?.companies[0].id === this.$store.state.user.companies[0].id) && isVehicleOwnedByCurrentCompany) {
                        return true;
                    }
                }

                return this.vehicle.deals.find(deal => deal.buyer_id === this.$store.state.user.id)
            },
            getStatusTooltip(status) {
                if (status === VehicleStatus.available.value) {
                    return 'Vehicle is available'
                } else if (status === VehicleStatus.onHold.value) {
                    return 'Vehicle is on hold'
                } else if (status === VehicleStatus.underOffer.value) {
                    return 'Vehicle has a hold request'
                }

                return VehicleStatus[status];
            },
        }
    }
</script>

<style scoped>
.vehicle-item-name {
    position: absolute;
    top: 10px;
    left: 16px;
}
.icon-list-holder {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 53px;
    background-color: #EAF8FF;
    border-radius: 0.5rem;
}
</style>
